export const useOptionsStore = defineStore('options', () => {
  const options = inject('options') as FilterMeta.Options
  const personsWithSpaces = computed(() => options.persons.map(id => `wd:${id}`).join(' '))
  const personsWithCommas = computed(() => options.persons.map(id => `wd:${id}`).join(', '))

  return {
    ...options,
    personsWithSpaces,
    personsWithCommas,
  }
})
